import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ModalBody } from 'reactstrap';
import { prepareBody, prepareHeader } from './services';
import {
  VrrButton,
  VrrCircleLoader,
  VrrModal,
  VrrTable
} from '../../../shared_components';
import BrandModal from '../../../menu/brand_modal';
import { fetchBrands, getBrands } from '../../../../redux/app/appActions';
import {
  fetchVrrSettings,
  getVrrPreferences
} from '../../../../redux/settings/settingAction';
import { TBrandsModal } from './types';
import { TBrandsAPI } from '../../../shared_components/vrr_dropdown/types';
import './BrandsModal.scss';

const BrandsModal: React.FC<TBrandsModal> = ({
  isOpen,
  onCancelAction,
  onSubmitAction
}) => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const brands = useSelector(getBrands);
  const currentBrand = useSelector(getVrrPreferences)?.current_brand_id;
  const [openNewBrandModal, setOpenNewBrandModal] = useState(false);
  const [newBrands, setNewBrands] = useState<TBrandsAPI[]>([]);

  useEffect(() => {
    return () => {
      setNewBrands([]);
    };
  }, []);

  useEffect(() => {
    if (brands) {
      setNewBrands([...brands]);
    }
  }, [brands]);

  const onAddBrand = () => {
    dispatch(fetchBrands());
    dispatch(fetchVrrSettings());
    setOpenNewBrandModal(false);
  };

  const onChange = (value: string, isChecked: boolean) => {
    let dataTable = [...newBrands];
    dataTable = dataTable.map((brand) =>
      brand.brand_id.toString() === value
        ? {
            ...brand,
            status:
              isChecked || brand.brand_id.toString() === currentBrand
                ? 'displayed'
                : 'hidden'
          }
        : brand
    );
    setNewBrands(dataTable);
  };

  const onChangeAll = (isChecked: boolean) => {
    let dataTable = [...newBrands];
    dataTable = dataTable.map((brand) =>
      brand.brand_id.toString() === currentBrand
        ? { ...brand, status: 'displayed' }
        : { ...brand, status: isChecked ? 'displayed' : 'hidden' }
    );
    setNewBrands(dataTable);
  };

  return (
    <VrrModal
      className="brands-modal"
      isOpen={isOpen}
      title={t('connected_brand.title')}
      modalBody={
        <ModalBody className="brands-modal-body">
          <VrrButton
            className="brand-dropdown-add-brand btn-with-icon-and-label icon-left"
            icon={{
              iconLabel: 'tim-icons icon-cloud-download-93'
            }}
            onClick={() => setOpenNewBrandModal(true)}
          >
            {t('main_navbar.brand_dropdown.button')}
          </VrrButton>
          <VrrCircleLoader isEnable={!newBrands}>
            {!newBrands?.length ? (
              t('connected_brand.brands_modal.body.no_available_brands')
            ) : (
              <VrrTable
                header={prepareHeader(onChangeAll)}
                body={prepareBody(newBrands, currentBrand, onChange)}
                tableProps={{
                  borderless: true,
                  striped: true,
                  className: 'brands-table'
                }}
              />
            )}
          </VrrCircleLoader>
          <BrandModal isOpen={openNewBrandModal} onCancelAction={onAddBrand} />
        </ModalBody>
      }
      toggleModal={onCancelAction}
      toggleValidation={() => {
        if (onSubmitAction) onSubmitAction(newBrands);
      }}
      scrollable
      dataCyCancelButton="user-profile-brands-modal-cancel"
    />
  );
};
export default BrandsModal;
